import styled from "styled-components";
import { Button } from "../../../../ui-components";

export const AsurionCTA = styled(Button)`
  margin-top: 32px;
  background-color: #782aca !important;
  color: #ffffff !important;
  border-color: #782aca !important;
  width: 260px;
  @media (max-width: ${props => props.theme.ui.breakpoints.lg}) {
    margin-top: 0px;
  }
`;

export const SectionWrapper = styled.section`
  padding: 96px 40px;

  @media (max-width: ${props => props.theme.ui.breakpoints.md}) {
    padding: 64px 20px;
  }
  @media (max-width: ${props => props.theme.ui.breakpoints.lg}) {
    gap: 32px;
  }
  background-color: #f0f0f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 42px;
  align-items: center;

  @media (max-width: ${props => props.theme.ui.breakpoints.lg}) {
    display: flex;
    flex-direction: column;
    gap: 32px;
    align-items: center;
  }
`;

export const ContentSection = styled.div`
  max-width: 531px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;

  @media (max-width: ${props => props.theme.ui.breakpoints.lg}) {
    max-width: 100%;
    text-align: center;
    align-items: center;
  }
`;
